import Barchart from './BarChart'
export default Barchart;